import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TablePreferencesService } from '../../services/wealthlane-award-services';

const usePostTablePreferences = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<boolean | undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TablePreferencesService.putApiAwardApiAppTablePreferencesTablePreferences(payload)
      );
    },
    {
      onSuccess: async (response) => {
        if (response ?? false) {
          await queryClient.invalidateQueries('getTablePreferences');
          toast.success(<ToastComponent label='Success' message={`Preferenced saved`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTablePreferences;
